(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('.announcement');
    if (!bar) return;

    var setAnnouncementHeight = function (height) {
      document.documentElement.style.setProperty('--announcement-height', height + 'px');
    };

    var measure = function () {
      if (bar && getComputedStyle(bar).display !== 'none') {
        setAnnouncementHeight(bar.offsetHeight);
      } else {
        setAnnouncementHeight(0);
      }
    };

    // Race weekend (Friday to Sunday of a listed round): show the Grand Prix message first; any other day the slide is removed.
    var race = bar.querySelector('[data-race-slide]');
    if (race) {
      var gp = '';
      try {
        var now = new Date(), today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
        (race.getAttribute('data-race-rounds') || '').split('\n').some(function (line) {
          var parts = line.split('|'), d = (parts[0] || '').trim().split('-');
          if (d.length !== 3 || !parts[1]) return false;
          var days = Math.round((Date.UTC(+d[0], +d[1] - 1, +d[2]) - today) / 864e5);
          if (days >= 0 && days <= 2) { gp = parts[1].trim(); return true; }
          return false;
        });
      } catch (e) {}
      if (gp) {
        race.querySelector('[data-race-message]').textContent = (race.getAttribute('data-race-text') || 'This Week: [gp]').replace('[gp]', gp);
        race.hidden = false;
        race.parentNode.insertBefore(race, race.parentNode.firstChild);
      } else {
        race.parentNode.removeChild(race);
      }
    }

    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    document.addEventListener('DOMContentLoaded', measure);
    measure();

    var root = document.querySelector('[data-announcement]');
    var closeBtn = bar.querySelector('[data-announcement-close]');

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.style.display = 'none';
        setAnnouncementHeight(0);
        var stored = [];
        try {
          stored = JSON.parse(localStorage.getItem('announcement-closed') || '[]');
        } catch (e) {}
        var key = 'announcement-' + bar.id;
        if (stored.indexOf(key) === -1) {
          stored.push(key);
          try { localStorage.setItem('announcement-closed', JSON.stringify(stored)); } catch (e) {}
        }
      });
    }

    if (!root) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('.announcement__slide'));
    if (slides.length <= 1) return;

    var current = 0;

    var show = function (index) {
      slides.forEach(function (slide, i) {
        slide.hidden = i !== index;
      });
    };

    var autoplay = parseInt(root.dataset.autoplay || '5000', 10);

    show(0);
    // No rotation for visitors who ask for reduced motion (WCAG 2.2.2). They would only ever see the first message, so show them all side by side instead.
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      slides.forEach(function (slide) { slide.hidden = false; });
      root.classList.add('announcement--inline');
      return;
    }
    setInterval(function () {
      current = (current + 1) % slides.length;
      show(current);
    }, autoplay);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class CollectionFilters extends HTMLElement {
    connectedCallback() {
      this.filterToggle = this.querySelector('[data-filter-toggle]');
      this.filterPanel = this.querySelector('[data-filter-panel]');
      this.filterOverlay = this.querySelector('[data-filter-overlay]');
      this.filterClose = this.querySelector('[data-filter-close]');
      this.sortSelect = this.querySelector('[data-sort-select]');
      this.priceApply = this.querySelector('[data-price-apply]');
      this.filterInputs = this.querySelectorAll('[data-filter-value]');

      if (this.filterToggle) {
        this.filterToggle.addEventListener('click', () => this.toggleFilters());
      }
      if (this.filterClose) {
        this.filterClose.addEventListener('click', () => this.closeFilters());
      }
      if (this.filterOverlay) {
        this.filterOverlay.addEventListener('click', () => this.closeFilters());
      }
      if (this.sortSelect) {
        this.sortSelect.addEventListener('change', () => this.onSortChange());
      }
      if (this.priceApply) {
        this.priceApply.addEventListener('click', () => this.onPriceApply());
      }
      this.filterInputs.forEach((input) => {
        input.addEventListener('change', () => this.onFilterChange(input));
      });
    }

    toggleFilters() {
      const isOpen = this.filterPanel.classList.toggle('is-open');
      this.filterOverlay.classList.toggle('is-open', isOpen);
      this.filterToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.style.overflow = isOpen ? 'hidden' : '';
    }

    closeFilters() {
      this.filterPanel.classList.remove('is-open');
      this.filterOverlay.classList.remove('is-open');
      this.filterToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    onSortChange() {
      const value = this.sortSelect.value;
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      window.location.href = url.toString();
    }

    onFilterChange(input) {
      window.location.href = input.dataset.filterUrl;
    }

    onPriceApply() {
      const minInput = this.querySelector('[data-price-min]');
      const maxInput = this.querySelector('[data-price-max]');
      const url = new URL(window.location.href);
      if (minInput && minInput.value) {
        url.searchParams.set(minInput.name, minInput.value);
      } else {
        url.searchParams.delete(minInput ? minInput.name : '');
      }
      if (maxInput && maxInput.value) {
        url.searchParams.set(maxInput.name, maxInput.value);
      } else {
        url.searchParams.delete(maxInput ? maxInput.name : '');
      }
      window.location.href = url.toString();
    }
  }
  customElements.define('collection-section', CollectionFilters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["exploded-helmet"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-exploded]').forEach(function (root) {
      var parts = {};
      root.querySelectorAll('[data-ex-part]').forEach(function (el) { parts[el.getAttribute('data-ex-part')] = el; });
      function marks(key) {
        return root.querySelectorAll('[data-ex-part="' + key + '"], [data-ex-badge="' + key + '"], [data-ex-guide="' + key + '"]');
      }
      function focusOn(keys) {
        root.classList.add('ex--focus');
        keys.forEach(function (k) { marks(k).forEach(function (el) { el.classList.add('is-on'); }); });
      }
      function focusOff() {
        root.classList.remove('ex--focus');
        root.querySelectorAll('.is-on').forEach(function (el) { el.classList.remove('is-on'); });
      }
      root.querySelectorAll('[data-ex-parts]').forEach(function (item) {
        var keys = item.getAttribute('data-ex-parts').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        item.addEventListener('mouseenter', function () { focusOff(); focusOn(keys); });
        item.addEventListener('mouseleave', focusOff);
        item.addEventListener('focus', function () { focusOff(); focusOn(keys); });
        item.addEventListener('blur', focusOff);
      });

      var btn = root.querySelector('[data-ex-toggle]');
      var label = root.querySelector('[data-ex-toggle-label]');
      if (btn) {
        var paused = false;
        var pauseText = label.textContent;
        btn.addEventListener('click', function () {
          paused = !paused;
          root.classList.toggle('is-paused', paused);
          btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
          label.textContent = paused ? 'Play animation' : pauseText;
        });
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { root.classList.toggle('is-offscreen', !e.isIntersecting); });
        }, { rootMargin: '80px' }).observe(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["helmet-anatomy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-helmet-anatomy]').forEach(function (root) {
      function set(n, on) {
        root.querySelectorAll('[data-ha-dot="' + n + '"], [data-ha-line="' + n + '"], [data-ha-part="' + n + '"]').forEach(function (el) {
          el.classList.toggle('is-active', on);
        });
        root.classList.toggle('ha--hover', on);
      }
      root.querySelectorAll('[data-ha-dot], [data-ha-part]').forEach(function (el) {
        var n = el.getAttribute('data-ha-dot') || el.getAttribute('data-ha-part');
        el.addEventListener('mouseenter', function () { set(n, true); });
        el.addEventListener('mouseleave', function () { set(n, false); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-bento"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    document.querySelectorAll('[data-home-bento]').forEach(function (root) {
      root.classList.add('hb--reveal');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      root.querySelectorAll('[data-hb-reveal]').forEach(function (el) { io.observe(el); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-home-hero]').forEach(function (hero) {
      if (!reduce) hero.classList.add('hh--motion');
      requestAnimationFrame(function () { hero.classList.add('is-ready'); });
      setTimeout(function () { hero.classList.add('is-ready'); }, 60);

      var video = hero.querySelector('.hh__video');
      if (!video) return;
      if (reduce) { video.remove(); return; }
      video.setAttribute('autoplay', '');
      var play = function () { var p = video.play(); if (p && p.catch) p.catch(function () {}); };
      play();
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) video.pause(); else play();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-standards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    document.querySelectorAll('[data-home-standards]').forEach(function (root) {
      root.classList.add('hs--reveal');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px' });
      root.querySelectorAll('[data-hs-reveal]').forEach(function (el) { io.observe(el); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var hero = document.querySelector('[data-lp-hero]');
    var bar = hero && hero.querySelector('[data-lp-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var link = bar.querySelector('[data-lp-sticky-link]');
    var past = false, designs = false;
    function sync() {
      var show = past && !designs;
      bar.classList.toggle('is-visible', show);
      if (link) link.tabIndex = show ? 0 : -1;
    }
    new IntersectionObserver(function (e) { past = !e[0].isIntersecting && e[0].boundingClientRect.top < 0; sync(); }, { threshold: 0 }).observe(hero.querySelector('.lp-hero__actions'));
    var target = document.getElementById('lp-designs');
    if (target) new IntersectionObserver(function (e) { designs = e[0].isIntersecting; sync(); }, { threshold: 0.05 }).observe(target);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manual-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var els = document.querySelectorAll('[data-mg-anim]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.classList.toggle('is-paused', !e.isIntersecting); });
    }, { rootMargin: '80px' });
    els.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mips-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-mips-hero]').forEach(function (root) {
      if (!reduce) root.classList.add('mh--motion');
      requestAnimationFrame(function () { root.classList.add('is-ready'); });
      setTimeout(function () { root.classList.add('is-ready'); }, 80);

      var video = root.querySelector('.mh__video');
      var btn = root.querySelector('[data-mh-toggle]');
      if (!video) return;
      var userPaused = reduce; // reduced motion: start paused, the visitor can press play
      var visible = true;

      function update() {
        var playing = !video.paused;
        root.classList.toggle('mh--playing', playing);
        if (btn) {
          btn.setAttribute('aria-pressed', playing ? 'false' : 'true');
          btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
        }
      }
      function play() { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
      function sync() {
        if (userPaused || !visible || document.hidden) video.pause(); else { video.preload = 'auto'; play(); }
      }
      video.addEventListener('play', update);
      video.addEventListener('pause', update);
      if (btn) btn.addEventListener('click', function () {
        userPaused = !video.paused;
        if (userPaused) video.pause(); else { video.preload = 'auto'; play(); }
      });
      document.addEventListener('visibilitychange', sync);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          sync();
        }, { threshold: 0.25 }).observe(video);
      } else { sync(); }
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mips-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    document.querySelectorAll('[data-mips-timeline]').forEach(function (root) {
      root.classList.add('mt--reveal');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px' });
      root.querySelectorAll('[data-mt-reveal]').forEach(function (el) { io.observe(el); });
      var list = root.querySelector('.mt__list');
      if (list) io.observe(list);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["model-lineup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-model-lineup]').forEach(function (root) {
      // Livery thumbnails swap the big helmet on hover/focus (links still go to the product).
      root.querySelectorAll('.ml__card').forEach(function (card) {
        var img = card.querySelector('.ml__image');
        var dots = card.querySelectorAll('.ml__dot');
        if (!img || !dots.length) return;
        var orig = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), alt: img.getAttribute('alt') };
        var warmed = false;
        function warm() {
          if (warmed) return;
          warmed = true;
          dots.forEach(function (d) { var i = new Image(); i.src = d.getAttribute('data-src'); });
        }
        function show(d) {
          warm();
          img.setAttribute('srcset', d.getAttribute('data-srcset'));
          img.setAttribute('src', d.getAttribute('data-src'));
          img.setAttribute('alt', d.getAttribute('data-alt'));
        }
        function restore() {
          img.setAttribute('srcset', orig.srcset || '');
          img.setAttribute('src', orig.src);
          img.setAttribute('alt', orig.alt || '');
        }
        dots.forEach(function (d) {
          d.addEventListener('mouseenter', function () { show(d); });
          d.addEventListener('focus', function () { show(d); });
        });
        card.addEventListener('mouseenter', warm);
        card.addEventListener('mouseleave', restore);
        card.addEventListener('focusout', function (e) {
          if (!card.contains(e.relatedTarget)) restore();
        });
      });

      // Reveal on scroll (never under reduced motion; content is visible without JS).
      if (reduce || !('IntersectionObserver' in window)) return;
      root.classList.add('ml--reveal');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      root.querySelectorAll('[data-ml-reveal]').forEach(function (el) { io.observe(el); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pinlock-insert"] && !Shopify.designMode) return;
  try {
    
  // Click-to-load videos: swap the thumbnail link for a youtube-nocookie player.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-pinlock-video]');
    if (!link || link.classList.contains('is-playing')) return;
    e.preventDefault();
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(link.getAttribute('data-pinlock-video')) + '?autoplay=1&rel=0&modestbranding=1';
    iframe.title = link.getAttribute('data-video-title') || 'Video';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    var box = document.createElement('div');
    box.className = link.className + ' is-playing';
    box.appendChild(iframe);
    link.replaceWith(box);
    iframe.focus();
  });

  // Collection page: follow the carousel's active slide (cs-carousel:change).
  document.addEventListener('cs-carousel:change', function (e) {
    var index = e.detail && typeof e.detail.index === 'number' ? e.detail.index : 0;
    document.querySelectorAll('[data-pinlock-map]').forEach(function (wrap) {
      var map = (wrap.getAttribute('data-pinlock-map') || '').split(',');
      var want = map[index] || '-';
      wrap.querySelectorAll('[data-pinlock-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-pinlock-panel') !== want;
      });
    });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pinlock-add]');
    if (!btn || btn.disabled) return;
    var label = btn.querySelector('[data-pinlock-add-label]');
    var buy = btn.closest('.pinlock-insert__buy');
    var status = buy ? buy.querySelector('[data-pinlock-status]') : null;
    var original = label ? label.textContent : '';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    btn.disabled = true;
    if (label) label.textContent = btn.getAttribute('data-adding-text') || original;
    if (status) status.textContent = '';
    document.dispatchEvent(new CustomEvent('cart-drawer:adding'));

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart-drawer:open'));
      })
      .catch(function () {
        document.dispatchEvent(new CustomEvent('cart-drawer:add-failed'));
        if (status) status.textContent = btn.getAttribute('data-error-text') || '';
      })
      .finally(function () {
        btn.disabled = false;
        if (label) label.textContent = original;
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-size-guide-zoom-wrap]').forEach(function (wrap) {
      var img = wrap.querySelector('.size-guide__image');
      if (!img) return;

      var zoomOutBtn = wrap.querySelector('[data-size-guide-zoom-out]');
      var zoomInBtn = wrap.querySelector('[data-size-guide-zoom-in]');
      var resetBtn = wrap.querySelector('[data-size-guide-zoom-reset]');
      var zoomLevelEl = wrap.querySelector('[data-size-guide-zoom-level]');

      var MIN_SCALE = 1;
      var MAX_SCALE = 4;
      var ZOOM_STEP = 2.5;
      var ZOOM_INCREMENT = 0.5;
      var state = { scale: 1, x: 0, y: 0 };

      function clamp(value, min, max) {
        return Math.min(Math.max(value, min), max);
      }

      function updateZoomUI() {
        if (zoomLevelEl) zoomLevelEl.textContent = Math.round(state.scale * 100) + '%';
        if (zoomOutBtn) zoomOutBtn.disabled = state.scale <= MIN_SCALE;
        if (zoomInBtn) zoomInBtn.disabled = state.scale >= MAX_SCALE;
        if (resetBtn) resetBtn.disabled = state.scale <= MIN_SCALE;
      }

      function applyTransform() {
        img.style.transform = 'translate(' + state.x + 'px, ' + state.y + 'px) scale(' + state.scale + ')';
        img.classList.toggle('is-zoomed', state.scale > 1);
        updateZoomUI();
      }

      function zoomTo(newScale, clientX, clientY) {
        var rect = img.getBoundingClientRect();
        var offsetX = clientX - rect.left - rect.width / 2;
        var offsetY = clientY - rect.top - rect.height / 2;
        state.scale = clamp(newScale, MIN_SCALE, MAX_SCALE);
        state.x = -offsetX * (state.scale - 1) / state.scale;
        state.y = -offsetY * (state.scale - 1) / state.scale;
        applyTransform();
      }

      function resetZoom() {
        zoomTo(MIN_SCALE, 0, 0);
      }

      function centerPoint() {
        var rect = img.getBoundingClientRect();
        return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
      }

      img.addEventListener('click', function (e) {
        if (dragMoved) {
          dragMoved = false;
          return;
        }
        if (state.scale > 1) {
          resetZoom();
          return;
        }
        zoomTo(ZOOM_STEP, e.clientX, e.clientY);
      });

      if (zoomInBtn) {
        zoomInBtn.addEventListener('click', function () {
          var c = centerPoint();
          zoomTo(state.scale + ZOOM_INCREMENT, c.x, c.y);
        });
      }

      if (zoomOutBtn) {
        zoomOutBtn.addEventListener('click', function () {
          var c = centerPoint();
          zoomTo(state.scale - ZOOM_INCREMENT, c.x, c.y);
        });
      }

      if (resetBtn) {
        resetBtn.addEventListener('click', resetZoom);
      }

      wrap.addEventListener('keydown', function (e) {
        if (e.key === '+' || e.key === '=') {
          e.preventDefault();
          var c = centerPoint();
          zoomTo(state.scale + ZOOM_INCREMENT, c.x, c.y);
        } else if (e.key === '-' || e.key === '_') {
          e.preventDefault();
          var c2 = centerPoint();
          zoomTo(state.scale - ZOOM_INCREMENT, c2.x, c2.y);
        } else if (e.key === '0' || e.key === 'Escape') {
          e.preventDefault();
          resetZoom();
        }
      });

      wrap.addEventListener('wheel', function (e) {
        if (!(e.ctrlKey || e.metaKey)) return;
        e.preventDefault();
        var step = e.deltaY > 0 ? -ZOOM_INCREMENT / 2 : ZOOM_INCREMENT / 2;
        zoomTo(state.scale + step, e.clientX, e.clientY);
      }, { passive: false });

      updateZoomUI();

      var DRAG_THRESHOLD = 5;
      var dragging = false;
      var dragMoved = false;
      var startX = 0;
      var startY = 0;
      var lastX = 0;
      var lastY = 0;

      img.addEventListener('pointerdown', function (e) {
        if (state.scale <= 1) return;
        dragging = true;
        dragMoved = false;
        startX = e.clientX;
        startY = e.clientY;
        lastX = e.clientX;
        lastY = e.clientY;
        img.setPointerCapture(e.pointerId);
      });

      img.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        state.x += (e.clientX - lastX);
        state.y += (e.clientY - lastY);
        lastX = e.clientX;
        lastY = e.clientY;
        if (!dragMoved) {
          var dx = e.clientX - startX;
          var dy = e.clientY - startY;
          if (Math.sqrt(dx * dx + dy * dy) > DRAG_THRESHOLD) dragMoved = true;
        }
        applyTransform();
      });

      ['pointerup', 'pointercancel'].forEach(function (evName) {
        img.addEventListener(evName, function () { dragging = false; });
      });

      var pinchStartDist = 0;
      var pinchStartScale = 1;

      function touchDist(touches) {
        var dx = touches[0].clientX - touches[1].clientX;
        var dy = touches[0].clientY - touches[1].clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }

      wrap.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 2) return;
        pinchStartDist = touchDist(e.touches);
        pinchStartScale = state.scale;
      }, { passive: true });

      wrap.addEventListener('touchmove', function (e) {
        if (e.touches.length !== 2 || !pinchStartDist) return;
        e.preventDefault();
        var dist = touchDist(e.touches);
        state.scale = clamp(pinchStartScale * (dist / pinchStartDist), MIN_SCALE, MAX_SCALE);
        applyTransform();
      }, { passive: false });

      wrap.addEventListener('touchend', function (e) {
        if (e.touches.length < 2) pinchStartDist = 0;
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
